import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeletePersonnelMutation } from "../../services/appln";

export default function DeletePersonnel(props: any): any {
  return (
    <DeletePanel
      deleteMutation={useDeletePersonnelMutation}
      deleteArgs={{ personnelId: props.personnelId }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deletePersonnelTitle}
      confirmationDialogMsg={strings.deletePersonnelConfirmation}
      errorDialogTitle={strings.deletePersonnelFailedTitle}
      errorDialogMsg={strings.deletePersonnelFailedMsg}
    />
  );
}
